import { DollarSign, Euro, PoundSterling } from "lucide-react";

const ICONS = {
  gbp: PoundSterling,
  usd: DollarSign,
  eur: Euro,
} as const;

/** Keeps the glyph on the buttons in step with what the visitor is charged. */
export const CurrencyIcon = ({ currency, className }: { currency: string; className?: string }) => {
  const Icon = ICONS[currency.toLowerCase() as keyof typeof ICONS] ?? DollarSign;
  return <Icon className={className} />;
};
